import { 
	createApp, 
	createSSRApp, 
	defineAsyncComponent, 
	ref
} from 'vue'
// import router from './router'
// .use(router)
import store from './store'
import vfmPlugin from "vue-final-modal";
import { 
	IAdvantageDataItem,
	IRoots,
	ISources, 
	IStoreState, 
	IVehicle, 
	IWindowScripts 
} from './types';
import { 
	refreshDisclaimers, 
	bindStaticHeader, 
	getAdvantageData, 
	getInitialVehicle,
	removeWhiteSpaceFromTextNodeAndNormalize, 
	bindJwAnalytics,
	bindCampaignAnalytics,
	initCmsScripts, 
	getRoots
} from './helpers';

const inputMaterialCode = document.querySelector('.sidebar #hidMaterialCode');

console.log('v1');

if (inputMaterialCode){
	let lastTimestamp = 0;
	setInterval(() => {
		const currentTimestamp = (window as any).retrievedImagesTimestamp;
		if (typeof currentTimestamp != 'undefined' && currentTimestamp != lastTimestamp){
			lastTimestamp = currentTimestamp;
			store.commit('DetailApp/setImages', (window as any).retrievedImages);
		}
	}, 1000);
}

store.subscribe((mutation: any, state: any) => {
	const p = (state as IStoreState).DetailApp.pricing;
	switch (mutation.type){
		case 'DetailApp/setPricing': {
			refreshDisclaimers(p);
			break;
		}
	}
});

const resizeTimer = ref(0);
const setScreenSize = (): void => {
	store.commit('DetailApp/setScreenSize', (window as any).innerWidth);
	store.commit('DetailApp/setScreenHeight', (window as any).innerHeight);
};
setScreenSize();
(window as any).addEventListener('resize', () => {
	clearTimeout(resizeTimer.value);
	(resizeTimer.value as any) = setTimeout(() => {
		setScreenSize();
	}, 250);
}, 250);

const allRoots: IRoots = getRoots();
const {
	topbarRoot,
	headerRoot,
	bannerRoot,
	demoNavRoot,
	overviewCtaRoot,
	imageGalleryRoot,
	videoGalleryRoot,
	cubeRoot,
	formRoot,
	advantageRoot,
	similarRoot,
	tdlRoot, 
	tdlCustomRoot, 
	fslContentRoot,
	novatedContentRoot
} = allRoots;

const loadedEls: any = ref([]);
const scrollObserver: any = ref(null);
function initScrollObserver(){
	const overviewEl: HTMLElement | null = document.getElementById('detail-overview-root');
	const aggHeadEl: HTMLElement | null = document.getElementById('agghead');
	
	scrollObserver.value = new IntersectionObserver(function(e){
		for (let i = 0; i != e.length; ++i){
			const id = e[i].target.getAttribute('id');
			if (e[i].isIntersecting && !loadedEls.value.includes(id)){
				loadedEls.value.push(id);
				loadSection(e[i].target);
				// if ("detail-overview-cta-root" == id){
				// 	loadSection(formRoot as Element);
				// }
			}
		}
	});

	aggHeadEl && scrollObserver.value.observe(aggHeadEl);
	topbarRoot && scrollObserver.value.observe(topbarRoot);
	headerRoot && scrollObserver.value.observe(headerRoot);
	bannerRoot && scrollObserver.value.observe(bannerRoot);
	demoNavRoot && scrollObserver.value.observe(demoNavRoot);
	overviewEl && scrollObserver.value.observe(overviewEl);
	overviewCtaRoot && scrollObserver.value.observe(overviewCtaRoot);
	imageGalleryRoot && scrollObserver.value.observe(imageGalleryRoot);
	videoGalleryRoot && scrollObserver.value.observe(videoGalleryRoot);
	cubeRoot && scrollObserver.value.observe(cubeRoot);
	formRoot && scrollObserver.value.observe(formRoot);
	advantageRoot && scrollObserver.value.observe(advantageRoot);
	similarRoot && scrollObserver.value.observe(similarRoot);
}

const urlParams = new URLSearchParams(window.location.search);
const tprSource = urlParams.has('tpr_source') ? parseInt(urlParams.get('tpr_source') || '') : 1;
const sources: ISources = {
	tprSource: isNaN(tprSource) ? 1 : tprSource
}
store.commit('DetailApp/setSources', sources);

const form_token = (window as unknown as IWindowScripts).form_token || '';
const form_privacy = (window as unknown as IWindowScripts).form_privacy || [];
store.commit('DetailApp/setFormToken', form_token);
store.commit('DetailApp/setFormPrivacy', form_privacy);

const openingInfo = (window as unknown as IWindowScripts).HourInfo;
store.commit('DetailApp/setOpeningInfo', openingInfo);

const isDev = process.env.NODE_ENV == 'development';
const sb: IVehicle = !isDev ? 
	(window as unknown as IWindowScripts).specBuilder || {} : 
	window.location.hash == '#test' ? require('@/specbuilders/test.json') : 
	// require('@/specbuilders/instock.json');
	require('@/specbuilders/virtual.json');
	
	// require('@/specbuilders/test.json');
	// require('@/specbuilders/instock-campaign.json');
	// require('@/specbuilders/bug.json');
	// require('@/specbuilders/noprice.json');
	// require('@/specbuilders/virtual-campaign.json');
	// require('@/specbuilders/demo.json');
	// require('@/specbuilders/testdrive.json');
	// require('@/specbuilders/testdrive-blank.json');
	// require('@/specbuilders/virtual-campaign.json');
const initialVehicle: IVehicle = getInitialVehicle(sb);

if (!(window as unknown as IWindowScripts).specBuilder){
	(window as unknown as IWindowScripts).specBuilder = sb;
}
if (!(window as unknown as IWindowScripts).financeInformation){
	const fi = {
		vehicleFinanceComparisonRate: "",
		vehicleFinanceInterestRate: "",
		vehicleFinanceRepayment: "",
		vehicleFinanceProduct: ""
	};
	(window as unknown as IWindowScripts).financeInformation = fi;
}

store.commit('DetailApp/setVehicle', initialVehicle);
store.commit('DetailApp/setOriginalBatch', initialVehicle.Batch || '');

if (initialVehicle.IsVirtual){
	store.dispatch('DetailApp/handleInitialLoad', initialVehicle);
}
else if (!initialVehicle.CurrentVariantCode && !!initialVehicle.Batch){
	store.dispatch('DetailApp/loadDemoImages');
}
else {
	store.dispatch('DetailApp/handleVehicleChange');
}

// if (topbarRoot){
// 	const DetailTopbar = defineAsyncComponent(() => import(/* webpackChunkName: "detail-topbar" */'@/DetailApp/DetailTopbar.vue'));
// 	createApp(DetailTopbar).use(store).mount(topbarRoot);
// }
if (tdlCustomRoot){
	removeWhiteSpaceFromTextNodeAndNormalize(tdlCustomRoot, true);
	const TestDriveLeadCustom = defineAsyncComponent(() => import(/* webpackChunkName: "test-drive-lead" */'@/TestDriveLead/TestDriveLead.vue'));
	createSSRApp(TestDriveLeadCustom, {...tdlCustomRoot.dataset}).use(store).mount(tdlCustomRoot as Element);
}
if (tdlRoot){
	removeWhiteSpaceFromTextNodeAndNormalize(tdlRoot, true);
	const TestDriveLead = defineAsyncComponent(() => import(/* webpackChunkName: "test-drive-lead" */'@/TestDriveLead/TestDriveLead.vue'));
	createSSRApp(TestDriveLead).use(store).mount(tdlRoot as Element);
}
if (headerRoot){
	const DetailHeader = defineAsyncComponent(() => import(/* webpackChunkName: "detail-header" */'@/DetailApp/DetailHeader.vue'));
	createApp(DetailHeader).use(store).use(vfmPlugin).mount(headerRoot);
}
else {
	bindStaticHeader();
}
if (fslContentRoot){
	const FSL = defineAsyncComponent(() => import(/* webpackChunkName: "detail-header-fsl-content" */'@/DetailApp/DetailHeaderFSLContent.vue'));
	createApp(FSL).use(store).use(vfmPlugin).mount(fslContentRoot);
}
if (novatedContentRoot){
	const NOV = defineAsyncComponent(() => import(/* webpackChunkName: "detail-header-novated-content" */'@/DetailApp/DetailHeaderNovatedContent.vue'));
	createApp(NOV).use(store).use(vfmPlugin).mount(novatedContentRoot);
}
if (bannerRoot){
	const DetailBanner = defineAsyncComponent(() => import(/* webpackChunkName: "detail-banner" */'@/DetailApp/DetailBanner.vue'));
	createApp(DetailBanner).use(store).use(vfmPlugin).mount(bannerRoot);
}
if (demoNavRoot){
	const DetailDemoNav = defineAsyncComponent(() => import(/* webpackChunkName: "detail-demo-nav" */'@/DetailApp/DetailDemoNav.vue'));
	createApp(DetailDemoNav).use(store).use(vfmPlugin).mount(demoNavRoot as Element);
}
if (formRoot){
	const phoneDiv = document.getElementById('detail-form-content');
	phoneDiv && phoneDiv.setAttribute('style', 'display:none');
}

function loadSection(target: Element){
	const id = target.getAttribute('id');
	if (!id || (loadedSections as any)[id]) return;

	console.log('LOAD SECTION', id)

	switch (target){
		case formRoot: {
			console.log('formRoot');
			const DetailForms = defineAsyncComponent(() => import(/* webpackChunkName: "detail-forms" */'@/DetailApp/DetailForms.vue'));
			createApp(DetailForms).use(store).mount(formRoot as Element);
			const phoneDiv = document.getElementById('detail-form-content');
			phoneDiv && phoneDiv.setAttribute('style', 'display:none');
			break;
		}
		case overviewCtaRoot: {
			console.log('overviewCtaRoot');
			const DetailOverviewCta = defineAsyncComponent(() => import(/* webpackChunkName: "detail-overview-cta" */'@/DetailApp/DetailOverviewCta.vue'));
			createApp(DetailOverviewCta).use(store).use(vfmPlugin).mount(overviewCtaRoot as Element);
			break;
		}
		case imageGalleryRoot: {
			console.log('imageGalleryRoot');
			const DetailImageGallery = defineAsyncComponent(() => import(/* webpackChunkName: "detail-image-gallery" */'@/DetailApp/DetailImageGallery.vue'));
			createApp(DetailImageGallery).use(store).use(vfmPlugin).mount(imageGalleryRoot as Element);
			break;
		}
		case videoGalleryRoot: {
			console.log('videoGalleryRoot');
			const DetailVideoGallery = defineAsyncComponent(() => import(/* webpackChunkName: "detail-video-gallery" */'@/DetailApp/DetailVideoGallery.vue'));
			createApp(DetailVideoGallery).use(store).use(vfmPlugin).mount(videoGalleryRoot as Element);
			break;
		}
		case cubeRoot: {
			console.log('cubeRoot');
			const DetailCube = defineAsyncComponent(() => import(/* webpackChunkName: "detail-cube" */'@/DetailApp/DetailCube.vue'));
			createApp(DetailCube).use(store).use(vfmPlugin).mount(cubeRoot as Element);
			break;
		}
		case advantageRoot: {
			console.log('advantageRoot');
			// removeWhiteSpaceFromTextNodeAndNormalize(advantageRoot, true);

			const advantageData: Array<IAdvantageDataItem> = getAdvantageData();
			store.commit('DetailApp/setAdvantages', advantageData);

			const DetailAdvantage = defineAsyncComponent(() => import(/* webpackChunkName: "detail-advantage" */'@/DetailApp/DetailAdvantage.vue'));
			// createSSRApp
			createApp(DetailAdvantage).use(store).use(vfmPlugin).mount(advantageRoot as Element);
			break;
		}
		case similarRoot: {
			console.log('similarRoot');
			const DetailSimilar = defineAsyncComponent(() => import(/* webpackChunkName: "detail-similar" */'@/DetailApp/DetailSimilar.vue'));
			createApp(DetailSimilar).use(store).mount(similarRoot as Element);
			break;
		}
	}

	handleLoaded(id);
}
const handleLoaded = (id: string) => {
	(loadedSections as any)[id] = true;
	let areAllLoaded = true;
	Object.values(allRoots).forEach(v => {
		if (!v) return;
		areAllLoaded = areAllLoaded && (loadedSections as any)[v.getAttribute('id')];
	});
	if (areAllLoaded){
		const loadedEvent = new CustomEvent("allSectionsLoaded");
		document.dispatchEvent(loadedEvent);
	}
}

const loadedSections = ref({});
Object.values(allRoots).forEach(v => {
	if (!v) return;
	(loadedSections as any)[v.getAttribute('id')] = false;
});
document.addEventListener('loadAllSections', () => {
	Object.values(allRoots).forEach(v => {
		if (!v) return;
		loadSection(v);
	});
});

initScrollObserver();
bindJwAnalytics();
initCmsScripts();
bindCampaignAnalytics();